import { render, staticRenderFns } from "./crudProject.vue?vue&type=template&id=769b3fef&scoped=true&"
import script from "./crudProject.vue?vue&type=script&lang=js&"
export * from "./crudProject.vue?vue&type=script&lang=js&"
import style0 from "./crudProject.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudProject.vue?vue&type=style&index=1&id=769b3fef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769b3fef",
  null
  
)

export default component.exports